class StorageService {

  static KEY_PREFIX = 'app_cache_';

  static setItem(key, data) {
    const cacheData = {
      host: window.location.hostname,
      timestamp: new Date().getTime(),
      data: data
    };
    localStorage.setItem(this.KEY_PREFIX + key, JSON.stringify(cacheData));
  }

  static getItem(key) {
    const raw = localStorage.getItem(this.KEY_PREFIX + key);
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw);
      const currentHost = window.location.hostname;

      // Check: if the host has changed, delete the old cache
      if (parsed.host !== currentHost) {
        this.removeItem(key);
        return null;
      }

      return parsed.data;
    } catch (e) {
      console.error("Error parsing storage data", e);
      return null;
    }
  }

  static removeItem(key) {
    localStorage.removeItem(this.KEY_PREFIX + key);
  }
}

export default StorageService;